<template>
   <div >
		<div v-if="!initialized">
			<i class="fas fa-spinner fa-spin fa-3x"></i>
		</div>
		<div v-if="initialized" class="wcarousel" >
			<div class="tools top">
				<div class="tools-row">

					<div class="change-size fa-2x">
						<a title="change size small" href="#"
						   v-on:click="previewSize = 'small'"
						   v-if="previewSize === 'big'"
						   class="fas fa-angle-double-left" ></a>

						<a title="change size big" href="#"
						   v-on:click="previewSize = 'big'"
						   v-if="previewSize !== 'big'"
						   class="fas fa-angle-double-right" ></a>
					</div>
					<div class="selectors" v-if="mode === 'multiple'">
						<a href='#'
						   v-if="items.length > 0 && items.length === selected.length"
						   v-on:click="toggleAll(false)"
						   class="fas fa-check-circle fa-2x select_all"

						></a>
						<a href='#'
						   v-if="items.length > 0 && items.length > selected.length"
						   v-on:click="toggleAll(true)"
						   class="far fa-circle fa-2x unselect_all"
						></a>
					</div>


				</div>
			</div>
			<virtual-list 
						  :debounce="200"
						  :size="size"
						  :remain="remain"
						  wtag="div"
						  :start="start"
					
			>
				  <!-- :onscroll="onscroll" -->
				<div v-for="(item, index) in items"
					 :key="index"
				>	<wxm-gallery-card :key="item.id"
									  :index="index"
									  :object-name="item.objectname"
									  :object-id="item.id"

									  :visible="item.visible"

									  :title="item.data.title"
									  :src="(previewSize === 'big' ? item.data['src-big'] : item.data['src-small'])"
									  :fileViewSrc="item.data.fileViewSrc"
									  v-on:image-clicked="onImageClicked"

									  :zoom="item.data['src-magnify']"

									  :with-metas-hiddable="true"
									  :metas="item.data.metas"

									  :status="item.data.status"

									  :with-btn-edit="false"
									  :with-btn-view="false"

									  :selectable="!(mode === 'single')"
									  :selected="item.selected"
									  v-on:set-selected="setSelected"

									  :with-btn-active="true"
									  :active="((active === index) || false)"
									  v-on:set-active="setItemActive"
									  
									  :with-btn-file-view="true"

									  v-on:preview-mouse-over="onPreviewMouseOver"
									  v-on:preview-mouse-leave="onPreviewMouseLeave"

					></wxm-gallery-card>

				</div>

			</virtual-list>

			<div class="tools bottom">
			
				<div class="tools-row">
					<div class="wcarousel-pager">
						<div class="wcarousel-pager-prev">
							<a href="#"
							   class="fas fa-2x fa-step-backward wcarousel-pagination-prev"
							   :class="{'wcarousel-pagination-disabled':start === 0}"
							   v-on:click="prev()"></a>
						</div>
						<div class="wcarousel-pager-pagination" >
							<span class="label label-info" v-text="nbrAssets"></span>
						</div>
						<div class="wcarousel-pager-next">
						<a href="#"
						   class="fas fa-2x fa-step-forward wcarousel-pagination-next"
						   :class="{'wcarousel-pagination-disabled':start >= items.length}"
						   v-on:click="next()"></a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
   
</template>
<script>
	// TODO : remplacer virtuallist par autre chose car l'import standard ne fonctionne pas avec IE
    //import virtualList from 'vue-virtual-scroll-list' 
    import WxmGalleryCard from '../../wxm-gallery-card/index.js';
    export default {
        name: "wxm-chain-edit-carousel",
        components : {
            WxmGalleryCard,
    //      'virtual-list' : virtualList
        },
     

		props:'form_object,damobjectname,snapshotkey,thumbnailSize,iframeSelector'.split(','),

		data:function(){
			return {

				//search : '',
				preventScrollPropagation : false,
				initialized : false,
				mode : "single",

				size : 200,
				remain : 3,

				itemSelection:{
					last : -1,
					listen : false
				},
				active : 0,
				loading : false,
				start : 0,
				items : [],

				previewSize : "small"
			}
		},
		mounted : function() {
			var self = this;
			self.previewSize = self.thumbnailSize;
			this.loadData().always(function(){
				self.initialize();
            });
		},
		watch:{
			active:function(newValue, previousValue){
				$(this.$el).trigger("active-changed" , [{
					value : newValue,
					previousValue : previousValue
				}]);
			},
			previewSize:function(newValue, previousValue){
				$(this.$el).trigger("size-changed" , [{
					value: newValue,
					previousValue : previousValue
				}]);
			},
			mode:function(newValue, previousValue){
				this.modeChanged();
			}
		},
		computed:{
			nbrAssets:function(){
				return boi18n.getMessage({
					bundleName:"/bov3/wcm",
					key : "wxm.chain.edit.carousel.nbr.assets",
					params : [ this.items.length ]
				});
				//return ""+this.items.length;
			},
			firstPartial:function(){
				for( var i = 0 , isize = this.items.length;i<isize;i++ ){
					if (!this.items[i].data){
						return i;
					}
				}
				return -1;
			},
			selected : {
				get:function(){
					var s = this.items.filter(function(item){
						return item.selected;
					}).map(function(item){
						return item.id
					});
					return s;
				},
				set:function(newValue){
					this.items.forEach(function(item){
						item.selected = ( $.inArray(item.id, newValue ) > -1 ? true : false );
					});
				}
			}
		},
		methods:{
			resize:function(h){
				var size = Math.max( 100,Math.ceil((h / this.remain)/10)*10);
				Vue.set(this,'size', size);
			},
			setMode:function(mode){
				Vue.set(this, 'mode' , mode);
			},
			onPreviewMouseOver:function(item){
				var event = item.event;
				if (!$(event.currentTarget).data("magnify")){
					$(event.currentTarget).magnify($.extend(true,{},window['wedia_bov3_magnify_options']||{}));
				}
				$(event.currentTarget).triggerHandler( "mouseenter" );
			},
			onPreviewMouseLeave:function(item){
				var event = item.event;
				$(event.currentTarget).triggerHandler( "mouseleave" );
			},
			onPreviewMouseMove:function(event){
			},
			modeChanged:function(){
			},
			initialize:function(){
				var self =this;
				$("body").off("keydown.listenselected").on("keydown.listenselected" , function(event){
					if (event.shiftKey){
						self.itemSelection.listen = true;
					}
				});
				$("body").off("keyuop.listenselected").on("keyup.listenselected" , function(event){
					if (event.shiftKey){
						self.itemSelection.listen = false;
					}
				});
/*
				$("body").off("keydown.carouselnavigation").on("keydown.carouselnavigation" , function(event){
					if (event.which === 38){
						event.preventDefault();
						if (event.shiftKey){
							self.slideTo(0)
						}else{
							self.prev();
						}
					}else if(event.which === 40){
						event.preventDefault();
						if (event.shiftKey){
							self.slideTo(self.items.length-1);
						}else{
							self.next();
						}
					}
				});
				*/
				$(self.$el).trigger("initialized");
				this.initialized = true;

			},
			onImageLoaded:function(item){
				Vue.set(item , 'loaded', true);
				item.imageLoaded = true;
			},
			getImageSource : function(item){
				return item.data['src-' + this.previewSize] || item.data['src-small'];
			},
			findPositionInArray:function(itemId, arr){
				for(var i = 0 , isize = arr.length;i<isize;i++){
					if (""+itemId === ""+arr[i].id) return i;
				}
				return -1;
			},
			findPosition:function(itemId){
				return this.findPositionInArray(itemId,this.items || [] );
			},
			setActiveItem:function(itemId){
				this.setActive(this.findPosition(itemId));
			},
			remove:function(index){
				if (this.active === index ) {
					this.active = -1;
				}
				this.items.splice(index,1);
			},
			toggleAll:function(selected){
				this.items.forEach(function(item){
					item.selected = selected;
				});
			},
			updateItemData:function(id, data){
				if (!data || typeof(data) !== 'object'){
					return;
				}
				var position = this.findPosition(id)
				if (position ===-1){
					return;
				}
				var item = this.items[position];
				if (item && item.id === id){
					Vue.set(item , 'data' , data);
				}

			},
			setSelected:function(item){
				this.items[item.index].selected = item.value;
				this.handleShiftSelection(item.index);
			},
			handleShiftSelection : function(index){
				if (this.itemSelection.listen && this.itemSelection.last > -1) {

					this.itemSelection.listen = false;

					var value = this.items[index].selected;
					// faut-il g�rer la s�lection multiple avec la touche SHIFT
					if (index > this.itemSelection.last) {
						for (var i = this.itemSelection.last; i < index; i++) {
							this.items[i].selected = value;
						}
					} else if (index < this.itemSelection.last) {
						for (var i = this.itemSelection.last; i >= index; i--) {
							this.items[i].selected = value;
						}
					}
				}
				this.itemSelection.last = index;
			},
			slideTo:function(index){
				if (index < 0) index =0;
				if (index > this.items.length ) index = this.items.length -1;
				Vue.set(this,'start', index);
				
			},
			next:function(){
				this.slideTo(this.start + 1);
			},
			prev:function(){
				this.slideTo(this.start - 1);
			},
			onscroll:function(event,data){
				if (this.loading) return;
				if (this.firstPartial === -1) return;
				if (this.firstPartial > data.end + 50){
					return;
				}
				this.updateData(data.end);
			},
			updateData:function(until){
				var dfd =new $.Deferred(),
					self = this,
					from = this.firstPartial,
					to = Math.max(until || -1 , this.firstPartial) + 30;

				if (from <= 0) from = 0;
				if( from > this.items.length) return;
				if (to <= from) to = from +1;
				if (to>= this.items.length) to = this.items.length;

				this.loading = true;
				this.load({
					from : from,
					to : to
				}).then(function(result){
					self.loading = false;
					if (result.items && result.items.length > 0){
						result.items.filter(function(item){
							return (item.data && typeof(item.data) === 'object');
						}).forEach(function (item) {
							self.updateItemData(item.id,item.data);
						});
					}
					dfd.resolve(result);
				});

				return dfd.promise();
			},
			loadData : function(){
				var self = this,
					dfd = new $.Deferred();
				this.loading = true;
				this.load().then(function(result){
					self.loading = false;
					self.items = result.items || [];
					self.setActive(0);
					dfd.resolve();
				}).fail(function(err){
					dfd.reject(err);
				});
				return dfd.promise();
			},
			removeItem:function(id){
				this.remove(this.findPosition(id));
			},
			getUrl:function(obj,id,bd){
				var url = null,
					self = this,
					dfd = new $.Deferred();

				if (!obj || !id){
					dfd.reject();
				}else{

					jQuery.ajax({
						url:boState.getContextPath() + "/bov3/datachainedit/actions/getdata.jspz",
						type:'POST',
						data:{
							"nofields" : true,
							"form_object":obj,
							"form_id":id,
							"damobjectname":self.damobjectname
						},
						beforeSend: function(){

						},
						success:function(res){
							var urlParams = {
								"form_action":"datanew",
								"form_object":self.damobjectname,
								"form_id":"0",
								"__action_config":"chainedit"
							};
							if (!res['_origin_id']){
								urlParams = {
									"form_action" : "datachainedit",
									"chainedit_error":"origin_id_missing",
									"form_id":id,
									"form_object":obj
								};
								self.removeItem(id,false);
							}

							var params = $.extend({}, bd || {} , urlParams ,res);
							url = boState.getContextPath() + "/wcmlight.jspz";
							if (url.indexOf("?") > -1){
								url += "&";
							}else{
								url += "?";
							}
							url += $.param(params);
							dfd.resolve(url);
						}
					});
				}
				//return url;
				return dfd.promise();
			},
			getActiveIndex:function(){
				return this.active;
			},
			setItemActive:function(item){
				this.setActive(item.index);
			},
			onImageClicked:function(item){

			},
			setActive:function(index){
				if (index < 0) index = 0;
				if (index>this.items.length) index = this.items.length-1;
				var self = this;
				this.active = index;
				this.slideTo(this.active);

			},
			getIds:function(){
				var ids = [];
				this.items.forEach(function(item){
					ids.push(item.id);
				})
				return ids;
			},
			load:function(data){
				var self = this,
					dfd = new $.Deferred();

				$.ajax({
					dataType : "json",
					url : boState.getContextPath() + "/bov3/datachainedit/actions/ajax_fetch_snapshot.jspz",
					type:'POST',
					data : $.extend(true, {}, data || {} , {
						form_object : this.form_object,
						snapshotkey : this.snapshotkey
					})
				}).then(function(res){
					dfd.resolve(res);
				});
				return dfd.promise();
			}
		}
     
    }

</script>